import { Button, Text } from '@lbcamden/lib-react';
import { FunctionComponent, useRef, useState } from 'react';
import { useNavigate } from 'react-router';

import { usePropertyList, useRoleInformation } from '~/client/hooks/storeHooks';
import { toPcrfaPropertyPage, toPropertyPage } from '~/client/utils/navigation';
import { Property } from '~/common/types/buildings';

import { PropertySelect } from './PropertySelect';
import { PropertySelectPageRoot, PropertySelectPageSearch } from './PropertySelectPage.styled';
import { PropertySelectPageListing } from './PropertySelectPageListing';

export const PropertySelectPage: FunctionComponent = () => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  const navigate = useNavigate();

  const { isAdmin, isNeighbourhood, isPcfra } = useRoleInformation();

  const properties = usePropertyList();

  const [selectedProperty, setSelectedProperty] = useState<Property>();

  const showBothButtons = isAdmin || (isNeighbourhood && isPcfra);

  const goToProperty = (pcfra?: boolean) => {
    if (!selectedProperty) {
      return;
    }
    const { propertyId } = selectedProperty;
    void navigate((pcfra ? toPcrfaPropertyPage : toPropertyPage)(propertyId));
  };

  const onClickContinue = () => goToProperty(showBothButtons ? false : isPcfra);

  const onClickContinueToPcfra = () => goToProperty(true);

  return (
    <PropertySelectPageRoot data-testid="property-select-page">
      <PropertySelectPageSearch>
        <Text variant="h1">Search for a property...</Text>
        <PropertySelect
          options={properties}
          value={selectedProperty}
          onChange={setSelectedProperty}
        />
        <Button
          ref={buttonRef}
          $mobileStretch
          disabled={!selectedProperty}
          onClick={onClickContinue}
        >
          Continue
        </Button>
        {showBothButtons && (
          <Button
            ref={buttonRef}
            $mobileStretch
            disabled={!selectedProperty}
            onClick={onClickContinueToPcfra}
          >
            Continue to PCFRA
          </Button>
        )}
      </PropertySelectPageSearch>
      <PropertySelectPageListing />
    </PropertySelectPageRoot>
  );
};
